import { NoiseClassificationIconMap } from './NoiseClassificationIconMap';

export const noiseClassificationSlugHasIcon = (
  slug: string | undefined
): slug is keyof typeof NoiseClassificationIconMap => {
  if (!slug) return false;
  return slug in NoiseClassificationIconMap;
};
